/**
 * The business behind iAdvocate, as registered — one source for every page
 * that names it (Contact, Refund, Shipping, Terms intro, landing footer).
 *
 * Transcribed from the GST registration certificate (Form GST REG-06) and the
 * Udyam certificate, 2026-10-18. The legal name is the GST legal name exactly
 * ("KOVAI DIGI TECH", two words): a tax invoice and Razorpay's KYC review both
 * check the site against it. When the owner's new entity (Oriko) is
 * registered it gets its own Razorpay account and this file changes.
 *
 * Contact addresses and phone numbers as the owner set them on 2026-11-03 (Sathish):
 * the iadvocate.ai mailboxes replace his personal address on every public page, and
 * the two numbers are published (before that, no phone number was, owner 2026-10-18).
 */
export const BUSINESS = {
  brand: 'iAdvocate',
  legalName: 'Kovai Digi Tech',
  gstin: '33AALFK0299G1Z9',
  addressLines: [
    '113B, First Floor, Balaji Nagar',
    'New Siddhapudur',
    'Coimbatore, Tamil Nadu 641044',
    'India',
  ],
  /** General enquiries. */
  contactEmail: 'contact@iadvocate.ai',
  /** Product support, and privacy or security questions. */
  supportEmail: 'support@iadvocate.ai',
  /** Billing, payments, refunds and plan activation. */
  accountsEmail: 'accounts@iadvocate.ai',
  legalEmail: 'legal@iadvocate.ai',
  /** The Grievance Officer (DPDP Act; IT Rules, 2021). */
  grievanceEmail: 'grievances@iadvocate.ai',
  phones: ['+91 85474 68423', '+91 83440 77711'],
  website: 'iadvocate.ai',
} as const;

/** "+91 85474 68423" -> "tel:+918547468423". */
export const telHref = (phone: string): string => `tel:${phone.replace(/\s+/g, '')}`;
